import { N20MainMenu, N50Breadcrumb, N60Footer } from '~/features/Navigation';
import { UmbracoTypes } from '~/lib/data-contract';
import { useFrame, usePage } from '~/services/umbraco/hooks';
import { Schema, SchemaTypes } from '~/shared/schema';
import { MetaFields } from '../../pages/shared/MetaFields';
import { StyledMain } from '../styled';
import Watchers from '../utils/Watchers';
import DynamicScripts from '../utils/DynamicScripts';

export default function Standard({ children }: { children?: React.ReactNode }) {
    const { data: frame } = useFrame();
    const { data: pageType } = usePage((page) => page.type);
    const { src: logo } = frame?.footer?.logoImage || {};

    return (
        <>
            <Schema
                type={SchemaTypes.Organization}
                props={{
                    logo,
                }}
            />
            <MetaFields />
            <DynamicScripts hideUserLink={pageType === UmbracoTypes.PageTypes.IP90BasketPage} />
            <Watchers />
            <N20MainMenu />
            <StyledMain>
                <N50Breadcrumb />
                {children}
            </StyledMain>
            <N60Footer />
        </>
    );
}
